import { Link } from 'react-router-dom';

export default function Footer() {
  const navLinks = [
    { path: '/', label: 'Home' },
    { path: '/about-us', label: 'About Reiken' },
    { path: '/portfolio', label: 'Portfolio' },
    { path: '/contact-us', label: 'Contact Us' },
  ];

  return (
    <footer className="bg-[#111111] text-white">
      <div className="px-6 sm:px-8 md:px-20 pt-14 sm:pt-20 pb-8 sm:pb-10">
        <div className="max-w-7xl mx-auto">
          <div className="grid grid-cols-1 sm:grid-cols-2 md:grid-cols-3 gap-10 sm:gap-12 md:gap-16 mb-12 sm:mb-16 pb-12 sm:pb-16 border-b border-white/10">
            {/* Brand */}
            <div className="sm:col-span-2 md:col-span-1">
              <img
                src="https://static.readdy.ai/image/25203592582f416a5bf3ad1425ed1a29/5f5463c4881efc978f2b332584d73b9a.png"
                alt="Reiken Construction Management"
                className="h-12 sm:h-14 w-auto mb-5 sm:mb-6 brightness-0 invert"
              />
              <p className="text-white/50 text-sm leading-relaxed font-light max-w-xs">
                New York's premier construction management firm for luxury retail, commercial, and government projects since 1995.
              </p>
            </div>

            {/* Navigation */}
            <div>
              <p className="text-xs uppercase tracking-[0.25em] text-white/40 mb-5 sm:mb-6">Navigation</p>
              <ul className="space-y-3">
                {navLinks.map((link) => (
                  <li key={link.path}>
                    <Link
                      to={link.path}
                      className="text-white/70 hover:text-white text-sm font-light transition-colors cursor-pointer whitespace-nowrap"
                    >
                      {link.label}
                    </Link>
                  </li>
                ))}
              </ul>
            </div>

            {/* Contact */}
            <div>
              <p className="text-xs uppercase tracking-[0.25em] text-white/40 mb-5 sm:mb-6">Contact</p>
              <ul className="space-y-4">
                <li className="flex items-start gap-3">
                  <div className="w-4 h-4 flex items-center justify-center mt-0.5 shrink-0">
                    <i className="ri-map-pin-line text-white/40 text-sm"></i>
                  </div>
                  <p className="text-white/70 text-sm font-light leading-relaxed">
                    969 Third Ave., Suite #4F<br />
                    New York, NY 10022
                  </p>
                </li>
                <li className="flex items-center gap-3">
                  <div className="w-4 h-4 flex items-center justify-center shrink-0">
                    <i className="ri-phone-line text-white/40 text-sm"></i>
                  </div>
                  <a
                    href="tel:9174320310"
                    className="text-white/70 hover:text-white text-sm font-light transition-colors cursor-pointer whitespace-nowrap"
                  >
                    917-432-0310
                  </a>
                </li>
                <li className="flex items-center gap-3">
                  <div className="w-4 h-4 flex items-center justify-center shrink-0">
                    <i className="ri-mail-line text-white/40 text-sm"></i>
                  </div>
                  <a
                    href="mailto:office@reikencm.com"
                    className="text-white/70 hover:text-white text-sm font-light transition-colors cursor-pointer whitespace-nowrap"
                  >
                    office@reikencm.com
                  </a>
                </li>
              </ul>
            </div>
          </div>

          <div className="flex flex-col sm:flex-row items-center justify-between gap-3 sm:gap-4 text-center sm:text-left">
            <p className="text-white/30 text-xs font-light">
              © 2026 Reiken Construction Management. All rights reserved.
            </p>
            <p className="text-white/30 text-xs font-light">
              Designed by{' '}
              <a
                href="https://www.BellportBranding.com"
                target="_blank"
                rel="noopener noreferrer nofollow"
                className="hover:text-white/60 transition-colors cursor-pointer whitespace-nowrap underline"
              >
                Bellport Branding
              </a>
            </p>
          </div>
        </div>
      </div>
    </footer>
  );
}
